import {
  afterNextRender,
  Component,
  ChangeDetectorRef,
  DestroyRef,
  ElementRef,
  inject,
  input,
  output,
  viewChild
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateDirective } from '@ngx-translate/core';
import { Breakpoint, BreakpointState, Lesson, MediaQueryService, PagePanelComponent, SliderComponent, SliderItemComponent } from '@tdwb/core';
import { LearnSavedVideoComponent } from '../../saved-lesson/learn-saved-video.component';

@Component({
  selector: 'td-wb-trading-learn-related-lessons',
  templateUrl: './trading-learn-related-lessons.component.html',
  styleUrls: ['./trading-learn-related-lessons.component.scss'],
  imports: [
    PagePanelComponent,
    SliderComponent,
    SliderItemComponent,
    LearnSavedVideoComponent,
    TranslateDirective
  ]
})
export class TradingLearnRelatedLessonsComponent {
  private static readonly CARD_MARGIN_DESKTOP: number = 30;
  private static readonly CARD_MARGIN_TABLET: number = 15;

  private readonly mediaQueryService = inject(MediaQueryService);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  readonly contextualLesson = input.required<Lesson>();
  readonly relatedLessons = input<Array<Lesson>>([]);
  readonly lessonSelected = output<Lesson>();
  protected readonly relatedLessonsSection = viewChild<ElementRef>('relatedLessonsSection');

  isDesktop: boolean;
  isMobile: boolean;
  width: number;

  constructor() {
    this.mediaQueryService.observe(Breakpoint.SM, Breakpoint.GT_MD, Breakpoint.GT_LG)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((breakpointState: BreakpointState): void => {
        this.isMobile = breakpointState.isBreakpointMatch(Breakpoint.SM);
        this.isDesktop = breakpointState.isBreakpointMatch(Breakpoint.GT_MD);
        this.setDynamicWidthForCard();
        this.changeDetectorRef.markForCheck();
      });

    afterNextRender((): void => {
      this.setDynamicWidthForCard();
      this.changeDetectorRef.markForCheck();
    });
  }

  selectLesson(lesson: Lesson, index: number): void {
    this.lessonSelected.emit(lesson);
    const relatedLessons = this.relatedLessons();
    if (relatedLessons[index] !== undefined) {
      relatedLessons[index] = this.contextualLesson();
      this.changeDetectorRef.markForCheck();
    }
  }

  trackById(_index: number, lesson: Lesson): string {
    return lesson?.uniqueKey;
  }

  private setDynamicWidthForCard(): void {
    if (this.isMobile) {
      this.width = 300;
    } else {
      this.width = (this.relatedLessonsSection()?.nativeElement?.clientWidth -
        (2 * (this.isDesktop ?
          TradingLearnRelatedLessonsComponent.CARD_MARGIN_DESKTOP : TradingLearnRelatedLessonsComponent.CARD_MARGIN_TABLET))
      ) / 3;
    }
  }
}
